import { Tabs } from '@ygtechnologies/rubus-ui';
import BookameraIntegration from './BokameraIntegration/BookameraIntegration';
import React from 'react';

interface ProjectIntegrations {
    projectId: number;
}

const ProjectIntegrations = ({ projectId }: ProjectIntegrations) => {
    return (
        <div>
            <Tabs activeId="bokamera" variant="pill" size="sm">
                <Tabs.Tab id="bokamera" label="Bokamera" />
            </Tabs>
            <BookameraIntegration projectId={projectId} />
        </div>
    );
};
export default ProjectIntegrations;
